<template>
  <div class="saturn-force2">
    <div class="saturn-force2-text">
      <span class="saturn-force2-span">GALAXY Saturn 40 <br>{{ $t('series.saturn') }}</span>
    </div>
    <div class="saturn-image">
      <img src="../../static/home/saturn.png" alt="">
    </div>
    <div class="saturn-force2-text2">
      <span class="saturn-force2-span2">GALAXY Saturn Series</span>
      <span class="saturn-force2-span2">{{ $t('series.saturn_desc1') }}</span>
    </div>
    <div class="saturn-force2-content3">
      <div class="saturn-force2-image3">
        <div class="saturn2-image">
          <img src="../../static/home/saturn2.png" alt="">
        </div>
        <div class="saturn3-image">
          <img src="../../static/home/saturn3.png" alt="">
        </div>
      </div>
      <div class="saturn-content3-bottom">
        <div class="saturn-content3-bottom-left">
          <span class="saturn-force2-add">+</span>
          <span>{{ $t('series.saturn_desc2') }}</span>
          <span class="saturn-force2-big-size">{{ $t('series.saturn_desc3') }}</span>
          <span>15 / 22 / 30 kw</span>
          <span>{{ $t('series.saturn_desc4') }}</span>
        </div>
        <div class="saturn-content3-bottom-right">
          <span class="saturn-force2-add">+</span>
          <span>{{ $t('series.saturn_desc5') }}</span>
          <span class="saturn-force2-big-size">{{ $t('series.saturn_desc6') }}</span>
          <span>22 ~ 55 kw</span>
          <span>{{ $t('series.saturn_desc7') }}</span>
          <!--          <span> (其实用不着这么高…)</span>-->
        </div>
      </div>
    </div>

    <div class="saturn-content4">
      <div class="saturn-content4-text1">
        <span>GALAXY</span>
        <span>Nebula Central Vacuum System</span>
        <!--        <span>星云 系列 中央真空系统</span>-->
      </div>
      <div class="saturn-content4-text2">
        <span>{{ $t('series.saturn_desc9') }}</span>
        <span>{{ $t('series.saturn_desc10') }}</span>
        <span>{{ $t('series.saturn_desc11') }}</span>
        <span>{{ $t('series.saturn_desc12') }}</span>
        <span>{{ $t('series.saturn_desc13') }}</span>
      </div>
    </div>

    <div class="saturn-content5">
      <div class="saturn-content5-image">
        <img src="../../static/home/saturn4.png" alt="">
      </div>

      <div class="saturn-content5-image2">
        <img v-if="this.$i18n.locale === 'zh'" src="../../static/home/saturn5.png" alt="">
        <img v-else src="../../static/home/saturn6.png" alt="">
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'AdsorptionForce3',
  data() {
    return {
      data: {
        language: this.$i18n.locale
      }
    }
  },
  mounted() {
    this.$gsap.set(['.saturn-force2-text2',
      '.saturn-force2-content3',
      '.saturn-content4-text1',
      '.saturn-content4-text2',
      '.saturn-content5-image',
      '.saturn-content5-image2'], {
      opacity: 0
    })

    this.$gsap.set([
      '.saturn-content5-image'
    ], {
      y: 100,
      x: 100,
    })
    const masterTimeline = this.$gsap.timeline({
      scrollTrigger: {
        trigger: '.saturn-image',
        start: 'top 75%',
        end: 'bottom 60%',
        toggleActions: 'play none none none',
        markers: false,
        // scrub: 3,
        once: true
      }
    })

    // 1
    masterTimeline.from('.saturn-image', {
      opacity: 0,
      y: 100,
      duration: 1,
      ease: 'power2.in'
    }, 1)

    masterTimeline.from('.saturn-force2-span', {
      opacity: 0,
      duration: 1,
      ease: 'power2.in'
    }, 2)

    // 2
    masterTimeline.to('.saturn-force2-span', {
      delay: 1,
      opacity: 0,
      duration: 1,
      ease: 'power2.in'
    }, 4)

    masterTimeline.to('.saturn-image', {
      y: -100,
      delay: 1,
      duration: 1,
      ease: 'power2.in'
    }, 4)

    masterTimeline.to('.saturn-force2-text2', {
      opacity: 1,
      delay: 1,
      duration: 1,
      ease: 'power2.in'
    }, 4)
    //
    // 3
    masterTimeline.to('.saturn-image', {
      y: -100,
      delay: 1,
      opacity: 0,
      duration: 1,
      ease: 'power2.in'
    }, 6)

    masterTimeline.to('.saturn-force2-text2', {
      opacity: 0,
      y: -100,
      delay: 1,
      duration: 1,
      ease: 'power2.in'
    }, 6)

    masterTimeline.to('.saturn-force2-content3', {
      opacity: 1,
      duration: 1.5,
      y: -100,
      delay: 1,
      ease: 'power2.in'
    }, 6)

    // 4
    masterTimeline.to('.saturn-force2-content3', {
      opacity: 0,
      y: -1000,
      duration: 1.5,
      delay: 1,
      ease: 'power2.in'
    }, 8.5)
    masterTimeline.to('.saturn-content4-text1', {
      opacity: 1,
      duration: 1.5,
      delay: 1,
      ease: 'power2.in'
    }, 8.5)
    masterTimeline.to('.saturn-content4-text1', {
      color: '#61cbf4',
      duration: 1.5,
      delay: 1,
      ease: 'power2.in'
    }, 12)
    masterTimeline.to('.saturn-content4-text2', {
      opacity: 1,
      duration: 1.5,
      delay: 1,
      ease: 'power2.in'
    }, 12)
    //
    // 5
    masterTimeline.to('.saturn-content4', {
      opacity: 0,
      y: -100,
      duration: 1.5,
      delay: 1,
      ease: 'power2.in',
    }, 15)

    // 6
    masterTimeline.to('.saturn-content5-image', {
      opacity: 1,
      x: 0,
      y: 0,
      duration: 1.5,
    }, 18)

    masterTimeline.to('.saturn-content5-image2', {
      opacity: 1,
      duration: 1.5,
    }, 20)
  }
}

</script>
<style scoped>
.saturn-force2 {
  position: relative;
  background-image: linear-gradient(#283a54, #000);
  height: 2500px;
}

.saturn-image {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  top: 15%;

  img {
  }
}

.saturn-force2-text {
  position: absolute;
  left: 38%;
  top: 10%;
}

.saturn-force2-span {
  color: #fff;
  font-size: var(--font-size-lg2);
}

.saturn-force2-text2 {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 30%;
  width: 100%;
}

.saturn-force2-span2 {
  color: #fff;
  font-size: var(--font-size-lg2);
}

.saturn-force2-content3 {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  top: 20%;
}

.saturn2-image {
  img {
    width: 65%;
  }
}

.saturn3-image {
  img {
    width: 65%;
  }
}

.saturn-content3-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: white;
  font-size: var(--font-size-lg);
  width: 100%;
  justify-content: space-around;
}

.saturn-content3-bottom-left {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.saturn-content3-bottom-right {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.saturn-force2-big-size {
  font-size: var(--font-size-lg2);
}

.saturn-force2-add {
  color: yellow;
  font-size: var(--font-size-xl2);
}

.saturn-content4 {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 15%;
  width: 100%;
  color: white;
  font-size: var(--font-size-xl);
}

.saturn-content4-text1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.saturn-content4-text2 {
  width: 70%;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.saturn-content5 {
  position: absolute;
  top: -5%;
}

.saturn-content5-image {
  img {
    width: 100%;
  }
}

.saturn-content5-image2 {
  margin-top: -20px;

  img {
    width: 80%;
  }
}

</style>
